import React from 'react';

const Logo = ({ size = 'large', className = '', colored = true, showText = true }) => {
  const sizes = {
    small: { icon: 28, text: 'text-xl' },
    medium: { icon: 36, text: 'text-2xl' },
    large: { icon: 52, text: 'text-4xl' },
  };

  const currentSize = sizes[size] || sizes.large;
  const colorClass = colored ? 'text-white' : 'text-gray-800';

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <img 
        src="/app-logo.png" 
        alt="MyLocalGo"
        style={{ 
          width: currentSize.icon, 
          height: currentSize.icon 
        }}
        className="rounded-lg drop-shadow-lg"
      />
      {showText && (
        <div className={`ml-2 font-bold ${currentSize.text} ${colorClass} drop-shadow-lg`}>
          MyLocalGo
        </div>
      )}
    </div>
  );
};

export default Logo;
